import doc from "../../static/doc.svg";
import pdf from "../../static/pdf.svg";

const ff =
  "-apple-system,SF Pro Text,SF UI Text,system-ui,Helvetica Neue,Helvetica,Arial,sans-serif";

const filePreview = ({
  name = "Document",
  type = "doc",
  size = "Indeterminately"
}) => {
  return new Promise(resolve => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const img = new Image();

    const canvasWidth = 160;
    const canvasHeight = 160;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    context.fillStyle = "rgb(241, 241, 241)";
    context.fillRect(0, 0, canvas.width, canvas.height);

    context.font = `500 16px ${ff}`;
    context.fillStyle = "#000000";
    context.fillText(
      `${name.length > 12 ? name.substring(0, 12) + "..." : name}`,
      15,
      27
    );

    context.font = `300 14px ${ff}`;
    context.fillStyle = "rgb(144, 147, 151)";
    context.fillText(size, 15, 50);

    context.font = `400 16px ${ff}`;
    context.fillStyle = "#000000";
    context.fillText("file", 65, 105);

    img.onload = () => {
      context.drawImage(img, 10, 80, canvasHeight / 3.5, canvasHeight / 3.5);
      resolve(canvas.toDataURL("image/png"));
    };

    switch (type) {
      case "application/pdf":
        img.src = pdf;
        break;
      default:
        img.src = doc;
        break;
    }
  });
};

export default filePreview;
